import { render, staticRenderFns } from "./MenuEditForm.vue?vue&type=template&id=58bcd755&"
import script from "./MenuEditForm.vue?vue&type=script&lang=js&"
export * from "./MenuEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58bcd755')) {
      api.createRecord('58bcd755', component.options)
    } else {
      api.reload('58bcd755', component.options)
    }
    module.hot.accept("./MenuEditForm.vue?vue&type=template&id=58bcd755&", function () {
      api.rerender('58bcd755', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/MenuArea/MenuEditForm.vue"
export default component.exports